import { httpX } from '@/plugins/http';

function extractUnreadCount(data, items) {
  if (data && typeof data.unreadCount === 'number') {
    return data.unreadCount;
  }
  return items.filter(item => !item.read && !item.readAt).length;
}

export async function loadNotifications({ commit }) {
  commit('Notifications.SET_LOADING', true);
  try {
    const { data } = await httpX.get('/notifications');
    const { items } = data;
    const unreadCount = extractUnreadCount(data, items);
    commit('Notifications.SET_ITEMS', items);
    commit('Notifications.SET_UNREAD_COUNT', unreadCount);
  } catch (err) {
    commit('Notifications.SET_ITEMS', []);
    commit('Notifications.SET_UNREAD_COUNT', 0);
    throw err;
  } finally {
    commit('Notifications.SET_LOADING', false);
  }
}

export async function refreshUnreadCount({ commit }) {
  try {
    const { data } = await httpX.get('/notifications/unread-count');
    if (data && typeof data.unreadCount === 'number') {
      commit('Notifications.SET_UNREAD_COUNT', data.unreadCount);
    }
  } catch (err) {
    throw err;
  }
}

export async function markAllAsRead({ state, commit }) {
  if (!state.unreadCount) {
    return;
  }
  const pendingIds = state.items
    .filter(item => !item.read && !item.readAt)
    .map(item => item.id)
    .filter(Boolean);
  commit('Notifications.MARK_ALL_READ');
  if (!pendingIds.length) {
    return;
  }
  try {
    await httpX.post('/notifications/mark-as-read', { ids: pendingIds });
  } catch {
    await loadNotifications({ commit });
  }
}

export async function markAsRead({ commit }, id) {
  commit('Notifications.MARK_READ', id);
  await httpX.post('/notifications/mark-as-read', { ids: [id] });
}

export function prependNotification({ commit }, notification) {
  commit('Notifications.PREPEND_ITEM', notification);
}
